import { Outlet, useLocation } from "react-router";
// import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/NavBar";
import ChatSystem from "../landing page/components/ChatSystem";
import { useSnapshot } from "valtio";
import { isBusinessDataStore } from "../../../store/isBusinessData";
import { isAnonClientDataStore } from "../../../store/isAnonClientData";
import { businessFibiClientStore } from "../../../store/businessFibiClient";
import FloatingActionButton from "../landing page/components/FloatingActionButton";

const Layout = () => {
  const { pathname } = useLocation();
  const hideOnPath = pathname === "/fibi-voice-interview-prep";
  const { isBusinessData } = useSnapshot(isBusinessDataStore);
  const { isAnonClientData } = useSnapshot(isAnonClientDataStore);
  const { fibiClientToken } = useSnapshot(businessFibiClientStore);

  return (
    <>
      {/* <Header /> */}
      <Navbar />
      {/* <div className="mt-24"> */}
      <Outlet />
      {!hideOnPath &&
        !isBusinessData &&
        !isAnonClientData &&
        !fibiClientToken && <ChatSystem />}

      {pathname === "/fibi-ai" && <FloatingActionButton />}
      {!hideOnPath && <Footer />}
    </>
  );
};

export default Layout;
